export class Menu {
  Descricao: string;
  LocalDoMenu: LocalDoMenu;
  Caminho: string;
  Selecionado: boolean;
  SubMenu: any;

  constructor(
    descricao: string,
    localDoMenu: LocalDoMenu,
    caminho: string,
    selecionado: boolean,
    SubMenu: any
  ) {
    this.Descricao = descricao;
    this.LocalDoMenu = localDoMenu;
    this.Caminho = caminho;
    this.Selecionado = selecionado;
    this.SubMenu = SubMenu;
  }
}

enum LocalDoMenu {
  Cadastros,
  Processos,
  Agenda,
  Financeiro,
  Peticao,
  Relatorios,
  Configuracoes,
  AdministrativoClientes
}
